// extracted by mini-css-extract-plugin
export default {"container":"dsgvo_container__SX4O3","header":"dsgvo_header__Q0C50"};